import { NgModule } from "@angular/core";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ShowroomRaskButtonComponent } from "./buttons/rask-button/showroom-rask-button.component";
import { ShowroomComponent } from "./showroom.component";
import { ShowroomValidationComponent } from "./validation/showroom-validation.component";

@NgModule({
    imports: [
        RaskCommonModule,
        ShowroomComponent,
        ShowroomRaskButtonComponent,
        ShowroomValidationComponent
    ],
    exports: [ShowroomComponent]
})
export class ShowroomModule { }
